export const calendly_script =
  "https://assets.calendly.com/assets/external/widget.js";

export const calendly_go_live_meet_link =
  "https://calendly.com/socialpi-meeting/go-live-with-socialpi-affiliate";
